import { ComplexValue } from 'app/types-shared';
import { DefaultFilter } from '../types-store';

const compareValue = (value: ComplexValue<number>, originalValue: ComplexValue<number>): boolean =>
  (value?.value ?? 0) !== (originalValue?.value ?? 0);

const compareFilters = (filter: DefaultFilter, originalFilter: DefaultFilter): boolean =>
  originalFilter
    ? filter.sequence !== originalFilter.sequence ||
    (filter.required ?? false) !== (originalFilter.required ?? false) ||
    (filter.myValue ?? false) !== (originalFilter.myValue ?? false) ||
    compareValue(filter.domain, originalFilter.domain) ||
    compareValue(filter.defaultValue, originalFilter.defaultValue) ||
    compareValue(filter.defaultValue2, originalFilter.defaultValue2) ||
    compareValue(filter.periodPredef, originalFilter.periodPredef)
    : true;

export const filtersHaveChanges = (filters: DefaultFilter[] = [], originalFilters: DefaultFilter[] = []): boolean => {

  if (filters.length !== originalFilters.length) {
    return true;
  }

  return filters.length > 0 && filters.some(filter => {

    const originalFilter = originalFilters.find(original => filter.domain?.value === original.domain?.value);

    return compareFilters(filter, originalFilter);
  });
};
